import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-not-verified" }
const _hoisted_2 = { class: "user-not-verified__title" }

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import { ModalContent, ModalFooter, modalVariant, type ModalVariant } from '@exchange/libs/modals/src';
import { type VerificationFlag } from '@exchange/libs/utils/launchdarkly/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserNotVerified',
  props: {
  currencySymbol: { type: String },
  linkTextKey: { type: String, required: true },
  textKey: { type: String, required: true },
  verification: { type: Object as PropType<VerificationFlag>, required: true },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.light },
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const text = computed(() => {
  if (props.currencySymbol) {
    return t(props.textKey, { currency: props.currencySymbol });
  }

  return t(props.textKey);
});
const buttonText = computed(() => t(props.linkTextKey));

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ModalContent), { variant: __props.variant }, {
      default: _withCtx(() => [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('modules.transactions.verification.title')), 1),
        _createElementVNode("p", null, _toDisplayString(text.value), 1)
      ]),
      _: 1
    }, 8, ["variant"]),
    _createVNode(_unref(ModalFooter), null, {
      default: _withCtx(() => [
        (__props.verification.ready)
          ? (_openBlock(), _createBlock(_component_x_button, {
              key: 0,
              class: "user-not-verified__verify",
              variant: "primary",
              size: "sm",
              text: buttonText.value,
              href: __props.verification.link
            }, null, 8, ["text", "href"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})